export default __webpack_public_path__ + "static/media/697.27e7cca4.png";